import { ReactNode } from "react";
import i18next from "i18next";
import { Icon } from "Components/UI";
import RadioButtons from "Components/UI/RadioButtons";
import { IExistingFileInDestination } from "Data/interfaces/Upload/ICheckUploadFilesResponse";

export type TAlertMoveFilesType = 'version-down' |
  'version-equal' |
  'version-up' |
  'version-obsolete';

export interface IAlertMoveFilesData {
  type: TAlertMoveFilesType;
  filesData: IExistingFileInDestination;
  checkData?: IExistingFileInDestination & {
    fileNameNewRevision?: string;
    fileNameCopy?: string;
  };
}

export const getAlertMoveFilesTitle = (type: TAlertMoveFilesType) => {
  const opts = {
    'version-down': i18next.t('listagemArquivos:moveFiles.versionDownTitle'),
    'version-equal': i18next.t('listagemArquivos:moveFiles.versionEqualTitle'),
    'version-up': i18next.t('listagemArquivos:moveFiles.versionUpTitle'),
    'version-obsolete': i18next.t('listagemArquivos:moveFiles.versionObsoleteTitle'),
  };
  return opts[type];
}

export const getAlertMoveFilesDescriptionHeader = (
  type: TAlertMoveFilesType,
  v1?: string,
  v2?: string
): ReactNode => {
  const opts = {
    'version-down': (
      <div className="titleAlertWrapper">
        <span className="titleAlert">
          {i18next.t('listagemArquivos:moveFiles.versionDownDesc', { v1, v2 })}
        </span>
      </div>
    ),
    'version-equal': (
      <div className="titleAlertWrapper">
        <span className="titleAlert">
          {i18next.t('listagemArquivos:moveFiles.versionEqualDesc', { v1, v2 })}
        </span>
      </div>
    ),
    'version-up': (
      <div className="titleAlertWrapper">
        <span className="titleAlert">
          {i18next.t('listagemArquivos:moveFiles.versionUpDesc', { v1, v2 })}
        </span>
      </div>
    ),
    'version-obsolete': (
      <div className="titleAlertWrapper">
        <span className="titleAlert">
          {i18next.t('listagemArquivos:moveFiles.versionObsoleteDesc', { v1 })}
        </span>
        <span className="titleAlert">
          {i18next.t('listagemArquivos:moveFiles.versionObsoleteNote')}
        </span>
      </div>
    ),
  };
  return opts[type];
}

export const getAlertMoveFilesDescriptionFooter = (
  type: TAlertMoveFilesType,
  fileId: string,
  name1?: string,
  name2?: string,
  onValueChange?: (fileId: string, value: string) => void
): ReactNode => {
  const opts = {
    'version-down': (
      <div className="descriptionAlertWrapper gap">
        <Icon
          icon="obsoleteArchive"
          customSize={16}
          className="descriptionAlertIcon"
        />
        <span className="descriptionAlert">
          {i18next.t('listagemArquivos:moveFiles.obsoleteFileAccessible')}
        </span>
      </div>
    ),
    'version-equal': (
      <div className="descriptionAlertWrapper">
        <div className="radioButtonsWrap">
          <RadioButtons
            options={[
              {
                value: name1 || '',
                label: (
                  <div className="newFileNameOption">
                    <div>{name1}</div>
                    <div className="titleOption">{i18next.t('listagemArquivos:moveFiles.newRevision')}</div>
                  </div>
                ),
              },
              {
                value: name2 || '',
                label: (
                  <div className="newFileNameOption">
                    <div>{name2}</div>
                    <div className="titleOption">{i18next.t('listagemArquivos:moveFiles.copy')}</div>
                  </div>
                ),
              },
            ]}
            onSelect={(value) => onValueChange && onValueChange(fileId, value as string)}
            defaultValue={name1}
          />
        </div>
      </div>
    ),
    'version-up': (
      <div className="descriptionAlertWrapper gap">
        <Icon icon="obsoleteArchive" customSize={16} className="descriptionAlertIcon" />
        <span className="descriptionAlert">
          {i18next.t('listagemArquivos:moveFiles.obsoleteFileAccessible')}
        </span>
      </div>
    ),
    'version-obsolete': (
      <div className="descriptionAlertWrapper">
        <Icon icon="aviso" customSize={16} className="descriptionAlertIcon" />
        <span className="descriptionAlert">
          {i18next.t('listagemArquivos:moveFiles.versionObsoleteNote')}
        </span>
      </div>
    ),
  };
  return opts[type];
}
